import React, { useEffect, useRef } from 'react';

const useCursorFollower = (blobRef, dotRef) => {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (window.matchMedia('(pointer: coarse)').matches) return;

    const pos = { x: -100, y: -100 };
    const target = { x: -100, y: -100 };

    const onMove = (e) => {
      target.x = e.clientX;
      target.y = e.clientY;
      if (dotRef.current) {
        dotRef.current.style.transform = `translate3d(${e.clientX - 4}px, ${e.clientY - 4}px, 0)`;
      }
    };

    const onEnterInteractive = (e) => {
      if (e.target?.closest?.('a, button, input, textarea, [role="button"]')) {
        blobRef.current?.classList.add('cursor-blob-hover');
      }
    };
    const onLeaveInteractive = (e) => {
      if (e.target?.closest?.('a, button, input, textarea, [role="button"]')) {
        blobRef.current?.classList.remove('cursor-blob-hover');
      }
    };

    window.addEventListener('mousemove', onMove);
    document.addEventListener('mouseover', onEnterInteractive);
    document.addEventListener('mouseout', onLeaveInteractive);

    let rafId;
    const tick = () => {
      pos.x += (target.x - pos.x) * 0.15;
      pos.y += (target.y - pos.y) * 0.15;
      if (blobRef.current) {
        blobRef.current.style.transform = `translate3d(${pos.x - 24}px, ${pos.y - 24}px, 0)`;
      }
      rafId = requestAnimationFrame(tick);
    };
    rafId = requestAnimationFrame(tick);

    return () => {
      window.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseover', onEnterInteractive);
      document.removeEventListener('mouseout', onLeaveInteractive);
      cancelAnimationFrame(rafId);
    };
  }, [blobRef, dotRef]);
};

const CursorBlob = () => {
  const blobRef = useRef(null);
  const dotRef = useRef(null);
  useCursorFollower(blobRef, dotRef);

  return (
    <>
      <div ref={blobRef} className="cursor-blob" aria-hidden="true" />
      <div ref={dotRef} className="cursor-dot" aria-hidden="true" />
      <style>{`
        .cursor-blob, .cursor-dot {
          position: fixed;
          top: 0; left: 0;
          pointer-events: none;
          z-index: 90;
          border-radius: 9999px;
          will-change: transform;
        }
        .cursor-blob {
          width: 48px; height: 48px;
          background: radial-gradient(circle at 30% 30%, #FFE55C, #FFD200);
          mix-blend-mode: multiply;
          opacity: 0.85;
          filter: blur(2px);
          transition: width 0.25s ease, height 0.25s ease, opacity 0.25s ease;
        }
        .cursor-blob.cursor-blob-hover {
          width: 84px; height: 84px;
          opacity: 0.65;
          filter: blur(6px);
        }
        .cursor-dot {
          width: 8px; height: 8px;
          background: #111;
          transition: opacity 0.2s ease;
        }
        @media (pointer: coarse) {
          .cursor-blob, .cursor-dot { display: none; }
        }
      `}</style>
    </>
  );
};

export default CursorBlob;
